import {CHANNELS_DB_A, DB_FIELDS, DB_TABLES} from "./Constans";
import Utils from "../utils/Utils";
import { Dates } from '../packages/dates';
import DeviceStorage from "../components/DeviceStorage/DeviceStorage";
import AndroidDataBase from "./offline/AndroidDataBase";
import EpgChannelApiMapper from './helpers/EpgChannelApiMapper.js';
import EpgChannelTask from "../requests/tasks/epg/EpgChannelTask";
import RequestManager from '../requests/RequestManager';
import settings from '../devices/all/settings';
import EpgPersistence from "src/AAF/Nepg/EpgPersistence";
import RecordingLocalUtil from '../utils/RecordingLocalUtil';
import logger from 'src/utils/logger/logger';
// DEXIE_LOCAL descomentar la linea siguiente
// import PersistentDataBase from "./offline/PersistentDataBase";

/**
 * @class EpgDataManager : To manage all information about EPG events
 * these data is stored in a persistent data base, which could change at any time for another one
 */

let instance = null;
class EpgDataManager {
  constructor() {
    if (!instance) {
      instance = this;
      this._activeDB = DeviceStorage.getItem('activeDB') || CHANNELS_DB_A // to know what db is active, default A
      // DEXIE_LOCAL descomentar y comentar la linea siguiente
      // this._db = new PersistentDataBase(CHANNELS_DB_A, DB_TABLES, DB_FIELDS);
      this._db = new AndroidDataBase();
      this._tag = `EpgDataManager`; // for debug
      this._dev = true; // for debug
    }
    return instance;
  }

  async clearDB() {
    return await this._db.destroy();
  }

  /**
   * @method select get stored channels in persistent data base by group_id
   * @param {string} event_id
   */
  async selectEvents(id_composite, event_id = null, group_id = null) {
    logger.debug('EpgDataManager selectEvents event_id', event_id, 'id_composite', id_composite);
    if(!id_composite) {
      id_composite = `${group_id}${event_id}`;
    }
    return await this._db.select(id_composite, event_id, group_id);
  }
  /**
   * @method selectEventsByTimeWindow get stored channels in persistent data base by group_id
   * @param {Array} group_ids
   * @param {int} start
   * @param {int} end
   */
  async selectEventsByTimeWindow(group_ids = [], start, end) {
    return await this._db.selectTimeWindow(group_ids, start, end);
  }
  /**
   * @method insert store channels in persistent data base
   * @param {Array} data channels array channels to store, each element has to have the key _id
   * @param {string} table
   */
  async insert(data = [], table/*, db*/) {
    logger.debug('EpgDataManager insert data', data, 'table', table);
    if (!table || data.length === 0 /*|| !db*/) {
      return new Promise(resolve => resolve(false));
    }
    return await this._db.insert(data, table);
  }

  async _selectEventsAux(id, start, end, index, result, stop) {
    result[index] = await this.selectEventsByTimeWindow(id, start, end);
    stop.push(1);
    //result[index] = events;
  }

  async getGroupIdsEventsByTimeWindowApi(groupIds = [], start = 0, end = 0) {
    logger.debug('[GETEVENTSAPI] groupIds, start, end:', groupIds, start, end);
    let apiStart, apiEnd;
    if(typeof start === 'string' ){
      apiStart = start;
    }
    else{
      apiStart = `${Utils.formatDatesWithOffset(new Dates().unix(start), 'YYYYMMDDHHmmss')}`;
    }
    if(typeof end === 'string' ){
      apiEnd = end;
    }
    else{
      apiEnd = `${Utils.formatDatesWithOffset(new Dates().unix(end), 'YYYYMMDDHHmmss')}`;
    }
    let events = [];
    const params = {
      date_from: apiStart,
      date_to: apiEnd,
      group_id: groupIds.join(',')
    };
    const epgChannelTask = new EpgChannelTask(params);
    const result = await RequestManager.addRequest(epgChannelTask);

    if (result && result.response) {
      events = EpgChannelApiMapper.mapEvents(result.response, groupIds);
    }

    return events;
  }

  async getGroupIdsEventsByTimeWindow(groupIds = [], start = 0, end = 0, cb = null) {
    logger.debug('[EpgDataManager] getGroupIdsEventsByTimeWindow ', groupIds, start, end);
    return new Promise(async (resolve) => {
      if (EpgPersistence.isDatabaseDataSource()) {
        if(settings.use_dexie) {
          let result = [];
          let stop = [];

          for (let i = 0; i < groupIds.length; i++) {
            this._selectEventsAux(groupIds[i], start, end, i, result, stop);
          }
          let idInterval = setInterval(() => {
            //if(result.length===groupIds.length){
            if (stop.length === groupIds.length) {
              clearInterval(idInterval);
              if (typeof cb === 'function') {
                logger.debug('[API EPG] [EpgDataManager] getGroupIdsEventsByTimeWindow events DATABASE: ', result);
                cb(result);
              }
              return resolve(result);
            }
          }, 50);
        }
        else{
          const events = await this._db.selectTimeWindow(groupIds, start, end);
          if (typeof cb === 'function') {
            cb(events);
          }
          return resolve(events);
        }
      }
      else {
        const eventsApi = await this.getGroupIdsEventsByTimeWindowApi(groupIds, start, end);
        if (typeof cb === 'function') {
          cb(eventsApi);
        }
        return resolve(eventsApi);
      }
    });
  }

  isFullEvent(event) {
    return (
      event.hasOwnProperty('id')
      && event.hasOwnProperty('group_id')
      && event.hasOwnProperty('name')
      && event.hasOwnProperty('date_begin')
      && event.hasOwnProperty('date_end')
      && event.hasOwnProperty('channel_id')
      && event.hasOwnProperty('description')
      && event.hasOwnProperty('duration')
      && event.hasOwnProperty('ext_eventimage_name')
      && event.hasOwnProperty('ext_recordable')
      && event.hasOwnProperty('parental_rating')
      && event.hasOwnProperty('type')
      && event.hasOwnProperty('ext_startover')
      && event.hasOwnProperty('ext_year')
      && event.hasOwnProperty('dvb_content')
      && event.hasOwnProperty('ext_catchup')
    )
  }

  async getCurrentEventByGroupId(group_id) {
    const now = Utils.now(true);
    let events = await this.getGroupIdsEventsByTimeWindow([group_id], now.unix(), now.unix());
    if (Array.isArray(events) && events.length > 0) {
      events = events.reduce(it => it);
      if (Array.isArray(events) && events.length > 0) {
        events = events.reduce(it => it);
        if (this.isFullEvent(events)) {
          return new Promise(resolve => resolve(events));
        }
        else {
          if (events.id) {
            return await this.selectEvents(events.id_composite, events.id, events.group_id);
          }
        }
        return new Promise(resolve => resolve(null));
      }
      return new Promise(resolve => resolve(null));
    }
    return new Promise(resolve => resolve(null));
  }

  async getEventByGroupIdByStartTime(group_id, startTime) {
    let events = await this.getGroupIdsEventsByTimeWindow([group_id], startTime, startTime);
    if (Array.isArray(events) && events.length > 0) {
      events = events.reduce(it => it);
      if (Array.isArray(events) && events.length > 0) {
        events = events.reduce(it => it);
        if (this.isFullEvent(events)) {
          return new Promise(resolve => resolve(events));
        }
        else {
          if (events.id) {
            return await this.selectEvents(events.id_composite, events.id, events.group_id);
          }
        }
        return new Promise(resolve => resolve(null));
      }
      return new Promise(resolve => resolve(null));
    }
    return new Promise(resolve => resolve(null));
  }

  async getNextEventByEvent(event) {
    if (!event) {
      return new Promise(resolve => resolve(null));
    }
    if (event.nextEventId) {
      logger.debug('EpgDataManager getNextEventByEvent event has next event id', event.nextEventId);
      return await this.selectEvents(null, event.nextEventId, event.group_id);
    }
    else {
      let events = [];
      if (event.date_end && event.group_id) {
        const start = event.date_end + 1;
        const end = new Dates().unix(event.date_end).add(12, 'h').unix();
        events = await this.getGroupIdsEventsByTimeWindow([event.group_id], start, end);
        if (Array.isArray(events) && events.length > 0) {
          events = events.reduce(it => it);
          if (events.length > 0) {
            const nextEvent = events[0];
            if (this.isFullEvent(nextEvent)) {
              logger.debug('EpgDataManager getNextEventByEvent event is full', nextEvent);
              return new Promise(resolve => resolve(nextEvent));
            }
            else {
              if (nextEvent.id) {
                return await this.selectEvents(nextEvent.id_composite, nextEvent.id, nextEvent.group_id);
              }
            }
            return new Promise(resolve => resolve(null));
          }
        }
      }
      return new Promise(resolve => resolve(null));
    }
  }

  async getPreviousEventByEvent(event) {
    if (!event) {
      return new Promise(resolve => resolve(null));
    }
    if (event.previousEventId) {
      logger.debug('EpgDataManager getPreviousEventByEvent event has previous event id', event.previousEventId);
      return await this.selectEvents(null, event.previousEventId, event.group_id);
    }
    else {
      let events = [];
      if (event.date_begin && event.group_id) {
        const start = new Dates().unix(event.date_begin).subtract(12, 'h').unix();
        const end = event.date_begin - 1;
        events = await this.getGroupIdsEventsByTimeWindow([event.group_id], start, end);
        if (Array.isArray(events) && events.length > 0) {
          events = events.reduce(it => it);
          if (events.length > 0) {
            const previousEvent = events[events.length - 1];
            if (this.isFullEvent(previousEvent)) {
              logger.debug('EpgDataManager event is full', previousEvent);
              return new Promise(resolve => resolve(previousEvent));
            }
            else {
              if (previousEvent.id) {
                return await this.selectEvents(previousEvent.id_composite, previousEvent.id, previousEvent.group_id);
              }
            }
            return new Promise(resolve => resolve(null));
          }
        }
      }
      return new Promise(resolve => resolve(null));
    }
  }

  async _selectNextEventByIdAux(event, index, result, stop) {
    if (event) {
      result[index] = await this.getNextEventByEvent(event);
    }
    else {
      result[index] = null
    }
    stop.push(1);
  }

  async _selectPreviousEventByIdAux(event, index, result, stop) {
    if (event) {
      result[index] = await this.getPreviousEventByEvent(event);
    }
    else {
      result[index] = null
    }
    stop.push(1);
  }

  async getPreviousCurrentNextEventByGroupId(group_id) {
    return new Promise(async (resolve) => {
      let result = [];
      let stop = [{}];
      const now = Utils.now(true);
      let event = await this.selectEventsByTimeWindow(group_id, now.unix(), now.unix());
      if (event && Array.isArray(event) && event.length > 0) {
        event = event.reduce(it => it);
        if (event && event.id) {
          result = [event, event, event];
          for (let i = 0; i < result.length; i++) {
            if (i === 0) {
              this._selectPreviousEventByIdAux(result[i], i, result, stop)
            }
            if (i === 2) {
              this._selectNextEventByIdAux(result[i], i, result, stop);
            }
          }
          let idInterval = setInterval(() => {
            if (stop.length === result.length) {
              clearInterval(idInterval);
              resolve(result);
            }
          }, 10);
        }
        else {
          resolve([null, null, null]);
        }
      }
      else {
        resolve([null, null, null]);
      }
    });
  }

  updateRecordings(recordings = []) {
    if (recordings && Array.isArray(recordings)) {
      if (EpgPersistence.isDatabaseDataSource()) {
        return this._db.updateRecordings(recordings);
      }else{
        return this.updateLocalRecordings(recordings);
      }
    }
    return new Promise(resolve => resolve(false));
  }

  updateLocalRecordings = async (recordings) =>{
    try {
      if(recordings && Array.isArray(recordings)){
        for(const x in recordings){
          const recording = recordings[x];
          if (!recording.id_composite) {
            recording.id_composite = `${recording.group_id}${recording.event_alf_id || recording.id}`;
          }
          if(recording.id){
            delete recording.id;
          }
          if(recording.group_id){
            delete recording.group_id;
          }
          RecordingLocalUtil.set(recording.id_composite,{
            ...recording
          });
        }
      }
      return new Promise(resolve => resolve(true));
    } catch (e) {
      return new Promise(resolve => resolve(false));
    }
  }
}

export default EpgDataManager;



// WEBPACK FOOTER //
// ./src/AAFPersistenceManager/EpgDataManager.js